import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiModule } from '../shared/ui/ui.module';
import { WidgetModule } from '../shared/widget/widget.module';

import { PagesRoutingModule } from './pages-routing.module';

import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbNavModule, NgbDropdownModule, NgbTooltipModule, NgbPaginationModule, NgbAccordionModule, NgbTypeaheadModule, NgbCollapseModule, NgbModalModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgPipesModule } from 'ngx-pipes';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DndModule } from 'ngx-drag-drop';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

import { CalendarComponent } from './calendar/calendar.component';
import { ChatComponent } from './chat/chat.component';
import { EcommerceModule } from './ecommerce/ecommerce.module';
import { KanbanComponent } from './kanban/kanban.component';
import { EmailModule } from './email/email.module';
import { UIModule } from './ui/ui.module';
import { IconsModule } from './icons/icons.module';
import { ChartModule } from './chart/chart.module';
import { FormModule } from './form/form.module';
import { TablesModule } from './tables/tables.module';
import { MapsModule } from './maps/maps.module';
import { ProfilComponent } from '../account/auth/profil/profil.component';
import { ToastModule } from 'primeng/toast';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DateFormatPipe } from '../shared/pipe/date-format.pipe';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { EcommerceRoutingModule } from './ecommerce/ecommerce-routing.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSliderModule } from 'ngx-slider-v2';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ListLocationsComponent } from './component/locations/list-locations/list-locations.component';


import { Dialog, DialogModule } from 'primeng/dialog';
import { AddParametrageMachineComponent } from './component/parametrages/machines/add-parametrage-machine/add-parametrage-machine.component';
import { EditParametrageMachineComponent } from './component/parametrages/machines/edit-parametrage-machine/edit-parametrage-machine.component';
import { ParametrageMachineComponent } from './component/parametrages/machines/parametrage-machine/parametrage-machine.component';
import { PaginatorModule } from 'primeng/paginator';
import { ParametrageProduitsComponent } from './component/parametrages/produits/parametrage-produits/parametrage-produits.component';
import { AddParametrageProduitsComponent } from './component/parametrages/produits/add-parametrage-produits/add-parametrage-produits.component';
import { EditParametrageProduitsComponent } from './component/parametrages/produits/edit-parametrage-produits/edit-parametrage-produits.component';
import { ParametrageUniteMesureComponent } from './component/parametrages/uniteMesure/parametrage-unite-mesure/parametrage-unite-mesure.component';
import { AddParametrageUniteMesureComponent } from './component/parametrages/uniteMesure/add-parametrage-unite-mesure/add-parametrage-unite-mesure.component';
import { EditParametrageUniteMesureComponent } from './component/parametrages/uniteMesure/edit-parametrage-unite-mesure/edit-parametrage-unite-mesure.component';
import { ListCooperativesComponent } from './component/cooperatives/list-cooperatives/list-cooperatives.component';
import { AddCooperativesComponent } from './component/cooperatives/add-cooperatives/add-cooperatives.component';
import { UpdateCooperativeComponent } from './component/cooperatives/update-cooperative/update-cooperative.component';
import { NouvelleLocationsComponent } from './component/locations/nouvelle-locations/nouvelle-locations.component';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { ReservationComponent } from './component/locations/reservation/reservation.component';
import { Skeleton, SkeletonModule } from 'primeng/skeleton';
import { ListAdministrateursComponent } from './component/administrateur/list-administrateurs/list-administrateurs.component';
import { AddAdministrateursComponent } from './component/administrateur/add-administrateurs/add-administrateurs.component';
import { UpdateAdministrateurComponent } from './component/administrateur/update-administrateur/update-administrateur.component';
import { SharedModule } from '../shared/shared.module';
import { MembresComponent } from './component/membres/membres.component';
import { StoksComponent } from './component/stoks/stoks.component';
import { ListSuperadminComponent } from './component/superadmin/list-superadmin/list-superadmin.component';
import { AddSuperadminComponent } from './component/superadmin/add-superadmin/add-superadmin.component';
import { UpdateSuperadminComponent } from './component/superadmin/update-superadmin/update-superadmin.component';
import { AgentsComponent } from './component/agents/agents.component';
import { PaiementDemandeComponent } from './component/locations/paiement-demande/paiement-demande.component';
import { ListCategorieProductComponent } from './component/parametrages/Product-categorie/list-categorie-product/list-categorie-product.component';
import { CategorieProduitComponent } from './component/parametrages/Product-categorie/categorie-produit/categorie-produit.component';
import { UpdateCategoreComponent } from './component/parametrages/Product-categorie/update-categore/update-categore.component';
import { VendeurComponent } from './component/vendeur/vendeur.component';
import { LogComponent } from './component/parametrages/log/log.component';
import { AllPaiementMarketplaceComponent } from './component/superadmin/all-paiement-marketplace/all-paiement-marketplace.component';
import { MarketplaceTransactionsPaiementComponent } from './component/superadmin/marketplace-transactions-paiement/marketplace-transactions-paiement.component';
import { TransactionDemandeLocationComponent } from './component/superadmin/transaction-demande-location/transaction-demande-location.component';
@NgModule({
  declarations: [
    ListAdministrateursComponent,
    AddAdministrateursComponent,
    UpdateAdministrateurComponent,
    ListLocationsComponent,
    AddParametrageMachineComponent,
    EditParametrageMachineComponent,
    ParametrageMachineComponent,
    ParametrageProduitsComponent ,
    AddParametrageProduitsComponent,
    EditParametrageProduitsComponent,
    ParametrageUniteMesureComponent,
    AddParametrageUniteMesureComponent,
    EditParametrageUniteMesureComponent,
    ListCooperativesComponent,
    AddCooperativesComponent,
    UpdateCooperativeComponent,
    NouvelleLocationsComponent,
    ReservationComponent,
    PaiementDemandeComponent,
    MembresComponent,
    AgentsComponent,
    StoksComponent,
    ListSuperadminComponent,
    AddSuperadminComponent,
    UpdateSuperadminComponent,

    ListCategorieProductComponent,
    CategorieProduitComponent,
    UpdateCategoreComponent,
    VendeurComponent,
    LogComponent,
    AllPaiementMarketplaceComponent,
    MarketplaceTransactionsPaiementComponent,
    TransactionDemandeLocationComponent,
    // DashboardComponent,
    // CalendarComponent,
    // ChatComponent,
    // KanbanComponent,
    // ProfilComponent,
     DateFormatPipe
  ],
  imports: [
// CommonModule,
    // FormsModule,
    PagesRoutingModule,
    //UiModule,
    CommonModule,
    FormsModule,
    DropzoneModule,
    ReactiveFormsModule,
    EcommerceRoutingModule,
    UiModule,
    CdkStepperModule,
    NgStepperModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbCollapseModule,
    NgSelectModule,
    NgxSliderModule,
    NgbModalModule,
    ToastModule,
    ConfirmDialogModule,
    NgxUiLoaderModule,
    DialogModule,
    PaginatorModule,
    CarouselModule,
    NgbPopoverModule,
    SkeletonModule,



  ],
  providers: [
  ]
})
export class PagesModule { }
